import React, { useEffect, useRef, useState } from 'react';
import Table from 'react-bootstrap/Table';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';

const OverviewTable = props => {
    const headers = ['Water', 'Electricity', 'Gas', 'GHG', 'Cost'];
    const subHeaders = ['Last month', 'This month', 'Increase'];

    const navigate = useNavigate();

    return (
        <Table className='overview-table'>
            <thead>
                <tr className='header-row-primary'>
                    <th className='header-border-right'></th>
                    {headers.map((header, _) => (
                        <th className='header-cell-center' colSpan={3}>{header}</th>
                    ))}
                </tr>
            </thead>
            <thead>
                <tr className='header-row-secondary'>
                    <th className='header-border-right'>Site</th>
                    {headers.map((header, _) => (
                        <>
                            <th className='text-center'>{subHeaders[0]}</th>
                            <th className='text-center'>{subHeaders[1]}</th>
                            <th className='header-cell-center'>{subHeaders[2]}</th>
                        </>
                    ))}
                </tr>
            </thead>

            <thread></thread>



            <tbody>
                {
                    props.isLoading &&
                    <tr >
                        <td colSpan={16} className='text-center'>
                            <CircularProgress />
                        </td>
                    </tr>
                }

                {props.tableData.map((row, i) => (
                    <tr key={i}>
                        <td className='site-cell'>
                            <span
                                id={`overview-tbl-site-elem-${row.siteID}`}
                                className='site-link'
                                onMouseEnter={() => {
                                    document.getElementById(`overview-tbl-site-elem-${row.siteID}`).style.textDecoration = 'underline';
                                }}
                                onMouseLeave={() => {
                                    document.getElementById(`overview-tbl-site-elem-${row.siteID}`).style.textDecoration = 'none';
                                }}
                                onClick={() => {
                                    // window.location.href = `/site/${row.siteID}`
                                    navigate(`/site/${row.siteID}`);
                                }}
                            >{row.siteName}</span>
                        </td>

                        {Object.entries(row).filter(([k]) => k !== 'siteName' && k !== 'siteID' && k !== 'active').flatMap(([key, value]) => [
                            <td key={`${i}-${key}-last`} className='data-cell'>
                                {key === 'cost' ? '$' : ''}{Math.round(value.prev / (key === 'ghg' ? 1000 : 1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                {key === 'electricity' ? <span className='unit-label'> kWh</span> : key === 'ghg' ? <span className='unit-label'> MT CO<sub>2</sub>e</span> : key !== 'cost' ? <span className='unit-label'> m<sup>3</sup></span> : ''}
                            </td>,

                            <td key={`${i}-${key}-this`} className='data-cell'>
                                {key === 'cost' ? '$' : ''}{Math.round(value.curr / (key === 'ghg' ? 1000 : 1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                {key === 'electricity' ? <span className='unit-label'> kWh</span> : key === 'ghg' ? <span className='unit-label'> MT CO<sub>2</sub>e</span> : key !== 'cost' ? <span className='unit-label'> m<sup>3</sup></span> : ''}
                            </td>,

                            <td key={`${i}-${key}-pct`} className='total-cell-border'>
                                {
                                    value.pctChange != null ?
                                    <span style={{color:value.pctChange > 0 ? 'red' : 'green'}}>{`${(Math.round(value.pctChange * 1000) / 10).toFixed(1)}%`}</span> :
                                    <span className='text-grey'>N/A</span>
                                }
                            </td>
                        ])}
                    </tr>
                ))}

                {
                    props.totals &&
                    <tr>
                        <td className='total-label-cell'>Total</td>

                        <td className='total-cell'>
                            {Math.round(props.totals?.water.prev).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} <span className='unit-label'> m<sup>3</sup></span>
                        </td>
                        <td className='total-cell'>
                            {Math.round(props.totals?.water.curr).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} <span className='unit-label'> m<sup>3</sup></span>
                        </td>
                        <td className='total-cell-border'>
                            {
                                props.totals?.water.pctChange == null ?
                                <span className='text-grey'>N/A</span> :
                                <span style={{color:props.totals.water.pctChange > 0 ? 'red' : 'green'}}>{`${(Math.round(props.totals.water.pctChange * 1000) / 10).toFixed(1)}%`}</span>
                            }
                        </td>

                        <td className='total-cell'>
                            {Math.round(props.totals?.electricity.prev).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} <span className='unit-label'> kWh</span>
                        </td>
                        <td className='total-cell'>
                            {Math.round(props.totals?.electricity.curr).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} <span className='unit-label'> kWh</span>
                        </td>
                        <td className='total-cell-border'>
                            {
                                props.totals?.electricity.pctChange == null ?
                                <span className='text-grey'>N/A</span> :
                                <span style={{color:props.totals.electricity.pctChange > 0 ? 'red' : 'green'}}>{`${(Math.round(props.totals.electricity.pctChange * 1000) / 10).toFixed(1)}%`}</span>
                            }
                        </td>

                        <td className='total-cell'>
                            {Math.round(props.totals?.gas.prev).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} <span className='unit-label'> m<sup>3</sup></span>
                        </td>
                        <td className='total-cell'>
                            {Math.round(props.totals?.gas.curr).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} <span className='unit-label'> m<sup>3</sup></span>
                        </td>
                        <td className='total-cell-border'>
                            {
                                props.totals?.gas.pctChange == null ?
                                <span className='text-grey'>N/A</span> :
                                <span style={{color:props.totals.gas.pctChange > 0 ? 'red' : 'green'}}>{`${(Math.round(props.totals.gas.pctChange * 1000) / 10).toFixed(1)}%`}</span>
                            }
                        </td>

                        <td className='total-cell'>
                            {Math.round(props.totals?.ghg.prev / 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} <span className='unit-label'> MT CO<sub>2</sub>e</span>
                        </td>
                        <td className='total-cell'>
                            {Math.round(props.totals?.ghg.curr / 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} <span className='unit-label'> MT CO<sub>2</sub>e</span>
                        </td>
                        <td className='total-cell-border'>
                            {
                                props.totals?.ghg.pctChange == null ?
                                <span className='text-grey'>N/A</span> :
                                <span style={{color:props.totals.ghg.pctChange > 0 ? 'red' : 'green'}}>{`${(Math.round(props.totals.ghg.pctChange * 1000) / 10).toFixed(1)}%`}</span>
                            }
                        </td>

                        <td className='total-cell'>
                            ${Math.round(props.totals?.cost.prev).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className='total-cell'>
                            ${Math.round(props.totals?.cost.curr).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className='total-cell-border'>
                            {
                                props.totals?.cost.pctChange == null ?
                                <span className='text-grey'>N/A</span> :
                                <span style={{color:props.totals.cost.pctChange > 0 ? 'red' : 'green'}}>{`${(Math.round(props.totals.cost.pctChange * 1000) / 10).toFixed(1)}%`}</span>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </Table>
    );
}

export default OverviewTable;
